module.exports = __webpack_public_path__ + "img/buy_super_id.8c0191b7.png";